import { ClassifaiSetting } from "../ClassifaiSetting";
import { CatalogItem } from "./CatalogItem";

export interface SearchFormCriteriaDto {
  systemKey?: string;
  elementKey?: string;
  field?: string;
  operator?: string;
  dataType?: string;
  value?: any;
  valueTo?: any;
  values?: string[];
}

export interface SearchFormRequestDto {
  formId?: string;
  condition?: string;
  criteria?: SearchFormCriteriaDto[];
}

export class TransferCatalogItem {

  constructor(
    public itemsToTransfer?: CatalogItem[],
    public targetItem?: CatalogItem,
    public isClassifAi?: boolean,
    public classifaiSetting?: ClassifaiSetting,
    public mergeStrategy?: 'use-source' | 'keep-target',
    public searchFilter?: string,
    public searchStates?: string[],
    public searchAndStates?: boolean,
    public searchFields?: string[],
    public searchMode?: string,
    public searchFormRequest?: SearchFormRequestDto
  ) {

  }
}
